import type { Dispatch, SetStateAction } from 'react';
import React from 'react';
import type { IRefineResultsProps } from './RepairLookupInterfaces';

interface IRepairLookupCtxProps {
  filterSet: IRefineResultsProps;
  setFilterSet: Dispatch<SetStateAction<IRefineResultsProps>>;
}

const RepairLookupCtx = React.createContext<IRepairLookupCtxProps | null>(null);

export default RepairLookupCtx;
